import React from 'react';
import { Box, InputAdornment, SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SearchInput from '../../Common/SearchInput';
import StyledButton from '../../Common/StyledButton';
import { ActivityTypeWithAllEnum, activityTypeOptionsWithAll } from '../../../types/activity';
import CustomDropdown from '../../CustomDropdown/CustomDropdown';
import { useAppSelector } from '../../../redux/hooks';
import { RootState } from '../../../redux/rootReducer';
import createPermissionCheckers from '../../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../../types/commonTypes';

interface IClientTableTopHeaderProps {
  handleNewActivityCreation: () => void;
  searchHandler: (_value: React.ChangeEvent<HTMLInputElement>) => void;
  searchText: string;
  activityFilterHandler: (_event: SelectChangeEvent<unknown>) => void;
  activityType: ActivityTypeWithAllEnum;
}

function ClientTableTopHeader({
  handleNewActivityCreation,
  searchHandler,
  searchText,
  activityFilterHandler,
  activityType,
}: IClientTableTopHeaderProps) {
  const { t } = useTranslation();
  const buttonStartIcon = '/assets/icons/add-circle-button.svg';
  const isActiveClient = useAppSelector(
    (state: RootState) => state.client.selectedClient?.isActive
  );

  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  return (
    <Box bgcolor="#fff" width="100%" display="flex" p="20px 24px" gap="30px">
      <Box display="flex" justifyContent="flex-start" flex="3">
        <SearchInput
          placeholder={`${t('common.search')}...`}
          onChange={searchHandler}
          value={searchText}
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img src="/assets/icons/magnifer.svg" alt="search" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box flex={1}>
        <CustomDropdown
          name="activityType"
          options={activityTypeOptionsWithAll}
          value={activityType}
          onChange={activityFilterHandler}
          placeholder={t('activity.activityTable.activityType')}
          isTranslationProvided
        />
      </Box>
      {checkPermissions(UserPermissionType.ACTIVITY_MODULE_ASSIGN_NEW_ACTIVITY) ? (
        <Box display="flex" justifyContent="flex-end" flex="1">
          <StyledButton
            onClick={handleNewActivityCreation}
            paddingY={8}
            paddingX={12}
            startIcon={buttonStartIcon}
            disabled={!isActiveClient}
          >
            {t('activity.activityTable.assignNewActivity')}
          </StyledButton>
        </Box>
      ) : null}
    </Box>
  );
}

export default ClientTableTopHeader;
